/** Диаметр круглого слота под мордочку Луни (спека 01, компонент 09). */
export const ERROR_STATE_AVATAR_SIZE = 30

/**
 * Грустная Луня над карточкой ошибки. Путь, а не импорт из `modules/lunya`: `shared` не имеет
 * права знать про слои выше (правило 1), поэтому позу берём файлом.
 */
export const ERROR_STATE_MASCOT_SRC = '/images/lunya-sad.png'
// Вдвое крупнее прежнего (правка основателя): на экране ошибки кроме Луни и одной строки
// ничего нет, и мелкая картинка читалась как иконка, а не как «Луня извиняется».
export const ERROR_STATE_MASCOT_SIZE = 264
